export function clone(objectToClone: any) {
    return JSON.parse(JSON.stringify(objectToClone));
}

export function formatUpdateProduitBody(objectToFormat: any) {
    const { approuve_web, approuve_web_ang, ...newObject } = objectToFormat;

    return newObject;
}